import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  ConsultaCobrosAutoserviciosComponent
} from './views/cobros-autoservicios/consulta-cobros-autoservicios/consulta-cobros-autoservicios.component';
import {
  ParametrosCobrosAutoserviciosComponent
} from './views/cobros-autoservicios/parametros-cobros-autoservicios/parametros-cobros-autoservicios.component';
import {
  SistemaCobrosAutoserviciosComponent
} from './views/cobros-autoservicios/sistema-cobros-autoservicios/sistema-cobros-autoservicios.component';
import {ParametrosCbComponent} from './views/conciliacion-bancaria/parametros-cb/parametros-cb.component';
import {
  SistemaConciliacionBancariaComponent
} from './views/conciliacion-bancaria/sistema-conciliacion-bancaria/sistema-conciliacion-bancaria.component';
import {ReporteComponent} from './views/reporte-facturacion-electronica/reporte.component';
import {
  ParametrosCbParamComponent
} from './views/conciliacion-bancaria/parametros-cb-param/parametros-cb-param.component';
import {
  SistemaConciliacionBancariaPlusComponent
} from './views/conciliacion-bancaria/sistema-conciliacion-bancaria-plus/sistema-conci-banca-plus.component';
import {
  ReglasOperacionBancaComponent
} from './views/conciliacion-bancaria/reglas-operacion-banca/reglas-operacion-banca.component';
import {AutorizacionCobrosComponent} from './views/autorizacion-cobros/autorizacion-cobros.component';
import {ExtractoBancarioComponent} from './views/extracto-bancario/extracto-bancario.component';
import {ExtractoBancarioConfigComponent} from "./views/extracto-bancario-config/extracto-bancario-config.component";
import {ReporteExtractoBancarioComponent} from "./views/reporte-extracto-bancario/reporte-extracto-bancario.component";
import {AnulaExtractoBancoComponent} from "./views/anula-extracto-banco/anula-extracto-banco.component";
import {
  ReporteConciliaExtratoRecuadoComponent
} from "./views/reporte-concilia-extrato-recuado/reporte-concilia-extrato-recuado.component";
import { ParamRechazoCobroComponent } from './views/param-rechazo-cobro/param-rechazo-cobro.component';
import { ParamConciExtractoFeriadosComponent } from './views/param-conci-extracto-feriados/param-conci-extracto-feriados.component';

const finanzasRoutes: Routes = [
  //cobros-autoservicios
  {path: 'finanzas/cobrosAutoservicios/sistemaCobrosAutoservicios', component: SistemaCobrosAutoserviciosComponent},// canActivate: [AuthGuard]},
  {
    path: 'finanzas/cobrosAutoservicios/parametrosCobrosAutoservicios',
    component: ParametrosCobrosAutoserviciosComponent
  },// canActivate: [AuthGuard]},
  {path: 'finanzas/cobrosAutoservicios/consultaCobrosAutoservicios', component: ConsultaCobrosAutoserviciosComponent},// canActivate: [AuthGuard]},
  // //conciliacion bancaria
  {path: 'finanzas/conciliacionBancaria/sistemaConciliacionBancaria', component: SistemaConciliacionBancariaComponent}, //canActivate: [AuthGuard]},
  {
    path: 'finanzas/conciliacionBancaria/sistemaConciliacionBancariaCustom',
    component: SistemaConciliacionBancariaPlusComponent
  }, //canActivate: [AuthGuard]},
  {path: 'finanzas/conciliacionBancaria/parametroConciliacionBanc', component: ParametrosCbComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/conciliacionBancaria/conciliacionBancParametro', component: ParametrosCbParamComponent},
  {path: 'finanzas/conciliacionBancaria/reglaOperacionBancaria', component: ReglasOperacionBancaComponent},
  //documentos electronicos
  {path: 'finanzas/reporteFacturacion', component: ReporteComponent},// canActivate: [AuthGuard]},
  //
  {path: 'finanzas/extractoBancario', component: ExtractoBancarioComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/autorizacionBancaria', component: AutorizacionCobrosComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/configExtractoBancario', component: ExtractoBancarioConfigComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/reporteExtractoBancario', component: ReporteExtractoBancarioComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/anulaExtrato', component: AnulaExtractoBancoComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/ReporteConciliaExtratoRecuado', component: ReporteConciliaExtratoRecuadoComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/paramRechazoCobro', component: ParamRechazoCobroComponent}, //canActivate: [AuthGuard]},
  {path: 'finanzas/configurarferiados', component: ParamConciExtractoFeriadosComponent},
];

@NgModule({
  imports: [RouterModule.forChild(finanzasRoutes)],
  exports: [RouterModule]
})
export class FinanzasRoutingModule {
}
